import { render, staticRenderFns } from "./manuscriptSearch.vue?vue&type=template&id=0637a4e4&scoped=true"
import script from "./manuscriptSearch.vue?vue&type=script&lang=js"
export * from "./manuscriptSearch.vue?vue&type=script&lang=js"
import style0 from "./manuscriptSearch.vue?vue&type=style&index=0&id=0637a4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637a4e4",
  null
  
)

export default component.exports